const f = timber_params.filters;

export const ProductFilterController = () => {
  if(!$('body').hasClass('post-type-archive-products') && !$('body').hasClass('tax-product_cat') && !$('body').hasClass('tax-product_industry')) {
    return;
  }

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const cat = urlParams.get('c');
  const ind = urlParams.get('i');

  if(cat) {
    const input = $('input[data-slug="' + cat + '"]').prop('checked', true);
    input.prop('checked', true).trigger('change');
    input.closest('.filters__item').find('.toggle-filter').attr('aria-expanded', true);
  }

  if(ind) {
    const input = $('input[data-slug="' + ind + '"]').prop('checked', true);
    input.prop('checked', true).trigger('change');
    input.closest('.filters__item').find('.toggle-filter').attr('aria-expanded', true);
  }

  if(cat || ind) {
    getProducts(0, f.current_page);
  }


  toggleFilters();
  filterProducts();

}





const filterProducts = () => {
  const $options = $('.filters input[type="checkbox"]');

  $options.each((i, el) => {
    $(el).on('change', (e) => {
      getProducts(0, f.current_page);
    })
  })


  $(document).on('click','.pagination a', (e) => {
    e.preventDefault();
    let parts = $(e.currentTarget).attr('href').split('/');
    let page = parts.pop() || parts.pop();  // handle potential trailing slash

    let offset = 0;
    if(page > 1) {
      offset = (page - 1) * f.posts_per_page;
    }
    getProducts(offset, page);
  })
}

const getProducts = (offset, page) => {
  let industry = [];
  let product_cat = [];
  const $selected = $('.filters input[type="checkbox"]:checked');

  $selected.each((i, el) => {
    if($(el).attr('data-type') === 'industry') {
      industry.push(el.value);
    }

    if($(el).attr('data-type') === 'product_cat') {
      product_cat.push(el.value);
    }
  })

  const data = {
    'action': 'get_filtered_products',
    'query': f.posts,
    'posts_per_page': f.posts_per_page,
    'offset': offset,
    'page': page,
    'is_search': f.is_search,
    'lang': f.lang,
    'industry': industry,
    'product_cat': product_cat
  };

  $.ajax({
    url : timber_params.ajaxurl,
    data : data,
    type : 'POST',
    beforeSend : ( xhr ) => {

      $('#posts .tease').css({ 'opacity': .1 });

      if($('.loader').length === 0) {
        $('#posts').prepend('<div class="loader" style="position: absolute; left: 50%;">loading</div>');
      }


    },
    success : ( data ) => {

      if( data ) {
        $('#posts').html(data);
        $('#posts .tease').css({ 'opacity': 1 });
      } else {
      }
    },
    error: (_MLHttpRequest, _textStatus, _errorThrown) => {
      console.dir(_errorThrown);
    },
  });
}


const toggleFilters = () => {
  $('.toggle-filter').each((i, el) => {

    $(el).on('click', (e) => {
      let expanded = $(el).attr('aria-expanded') === 'true' || false;
      $(el).attr('aria-expanded', !expanded);
    })
  });

}



// WEBPACK FOOTER //
// ./src/js/controllers/ProductFilterController.js